'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Box } from '@terra/ui-styled-system';
import { IconButton, Input } from '@terra/ui-design-system';
import { EyeIcon, ViewOffIcon } from '@terra/ui-icons';

type ProxyPasswordInputProps = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
};

export function ProxyPasswordInput({
  value,
  placeholder,
  onChange,
}: ProxyPasswordInputProps) {
  const tCommon = useTranslations('common');
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Box position="relative" w="full">
      <Input
        size="sm"
        type={isVisible ? 'text' : 'password'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        pr={8}
      />
      <IconButton
        size="xs"
        variant="ghost"
        position="absolute"
        right="1"
        top="50%"
        transform="translateY(-50%)"
        onClick={() => setIsVisible((previous) => !previous)}
        aria-label={
          isVisible ? tCommon('hidePassword') : tCommon('showPassword')
        }
      >
        {isVisible ? <ViewOffIcon size={14} /> : <EyeIcon size={14} />}
      </IconButton>
    </Box>
  );
}
